module.exports = __webpack_public_path__ + "static/media/login-logo.ce7c9e8f.png";